define(["require", "exports", "./toolHost", "./helpers", "./KeyedCollection"], function (require, exports, toolHost_1, helpers_1, KeyedCollection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // NOTE(abbas): Global variable that can be accessed by a tool to get at the tool host callbacks
    exports.toolHost = new toolHost_1.ToolHost();
    exports.helpers = new helpers_1.Helpers();
    exports.keyedCollection = new KeyedCollection_1.KeyedCollection();
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/index.ts
// module id = 572
// module chunks = 3